module.exports = __webpack_public_path__ + "static/media/menu-help-centre-icon.01b0f3b9.svg";